export enum EndResultLevel {
  EXCELLENT,
  VERY_GOOD,
  GOOD,
  MEDUIM,
  BAD,
  VERY_BAD,
  LOOSE
}
